import { reduxRequest } from "../../../../common/utils/reduxRequest";
import {
  DeliveryDaySlotsLoading,
  GetDeliveryDaySlots,
  UpdateDeliveryDaySlots,
  GetDeliverySlotDays,
  UpdateDeliverySlotDays,
} from "./Action";

export const getDeliveryDaySlotsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: DeliveryDaySlotsLoading,
    loadingType: "list_day_slots",
    successFunction: GetDeliveryDaySlots,
    url: `/admin/lookups/delivery_day_slots?day_of_week=${variables?.day_of_week}`,
    method: "get",
    variables,
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const updateDeliveryDaySlotsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: DeliveryDaySlotsLoading,
    loadingType: "update_day_slots",
    successFunction: UpdateDeliveryDaySlots,
    url: `/admin/lookups/delivery_day_slots`,
    method: "put",
    data: variables?.body,
    action: variables?.action,
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getDeliveryTimeSlotDaysRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: DeliveryDaySlotsLoading,
    loadingType: "get_slot_days",
    successFunction: GetDeliverySlotDays,
    url: `/admin/lookups/delivery_day_slots/${variables?.delivery_time_id}/days`,
    method: "get",
    variables,
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const updateDeliveryTimeSlotDaysRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: DeliveryDaySlotsLoading,
    loadingType: "update_slot_days",
    successFunction: UpdateDeliverySlotDays,
    url: `/admin/lookups/delivery_day_slots/${variables?.delivery_time_id}/days`,
    method: "put",
    data: variables?.body,
    action: variables?.action,
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};
